import * as React from 'react';
import { useState, useEffect } from 'react';
import { useQuery, Query, Direction } from './Query';
import { FilterHeader } from './QueryTable';

interface SortHeaderProps {
    title: string;
    field: string;
    automationId?: string;
}

export const SortHeader = ({ title, field, automationId = null }: SortHeaderProps) => {

    const { ordering, applyOrdering } = useQuery();
    const [ordered, setOrdered] = useState<Direction>();

    useEffect(() => {
        const ordered = ordering.find(order => order.field === field);
        setOrdered(ordered ? ordered.condition : null);
    }, [ordering]);

    const handleSort = () => {
        let direction: Direction = 'asc';

        if (ordered === 'asc')
            direction = 'desc';

        applyOrdering([{ field: field, condition: direction }]);
    }

    return (
        <FilterHeader automationId={automationId} sorted={ordered} onSort={handleSort}>{title}</FilterHeader>
    );
}